<template>
  <div class="filter-save__preset">
    <h3 class="text-lg leading-6 pb-1 font-medium text-gray-900 border-b border-gray-200">
      {{title}}
    </h3>
    <form @submit.prevent="savePreset">
      <div class="text-default">
        <div class="mb-4">
          <fg-input :label="$t('filters.tags.filterSavePreset.name')"
                    :placeholder="$t('filters.tags.filterSavePreset.name')"
                    v-model="model.name">
          </fg-input>
        </div>
        <div
          class="px-4 py-3 border-t rounded-b-lg -mx-3 -mb-3 border-gray-200 bg-gray-50 text-center sm:px-6 overflow-hidden">
          <submit-button outline @click="cancelFilter" type="info">
            {{$t('generic.cancel')}}
          </submit-button>
          <submit-button :disabled="!canSave"
                         native-type="submit"
                         class="ml-2">
            {{$t('generic.save')}}
          </submit-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'filter-save-preset',
    props: {
      title: String,
    },
    data: function () {
      return {
        model: {
          name: null,
        }
      }
    },
    computed: {
      canSave () {
        return this.model.name !== ''
      }
    },
    methods: {
      cancelFilter () {
        this.$emit('cancel')
        this.resetModel()
      },
      resetModel () {
        this.model = {
          name: ''
        }
      },
      async savePreset () {
        if (!this.canSave) {
          return
        }
        this.$emit('save-filter', {
          ...this.model
        })
      },
    },
  }
</script>
<style lang="scss">
  .filter-save__preset {
    min-width: 350px;
  }
</style>
